export default __webpack_public_path__ + "static/media/12.4e3a2798.jpg";